import FileUpload from "components/Common/file-upload/file-upload.component"
import { ImagePreview } from "components/Common/file-upload/file-upload.styles";
import { SuccessOk } from "configs/statusCode";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
    Col, Row, Modal, ModalBody, ModalHeader,
} from "reactstrap";

const UploadReceiptModal = ({rModal, setRModal,setStatus, setShouldGetData, dealId, Service}) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false)
    const [uploadState, setUploadState] = useState(false)
    const AuthData = useSelector(state => state.Auth)
    const [formState, setFormState] = useState({
        media_id: '',
        media_id_path: '',
    })

    const updatedAttachment = (attachments, type) => {
        const mediaObj = {
            [`${type}`]: attachments[0] ?.id,
            [`${type}_path`]: attachments[0] ?.path,
        }
        setFormState({ ...formState, ...mediaObj })
    }

    // FILE UPLOAD
    const deleteAttachment = (_, type) => {
        const mediaObj = {
            [type]: null,
            [`${type}_path`]: null,
        }
        setFormState({ ...formState, ...mediaObj })
    }
    const SubmitHandler = () => {
        if (!formState.media_id) {
            return toast.error("Please upload reciept picture")
        }

        setLoading(true)
        const data = {
            deal_id: dealId,
            reciept_id: formState.media_id
        }
        Service.uploadReciept(data).then(res => {
            if (res && res.status === SuccessOk) {
                toast.success("Receipt Uploaded Successfully")
                // setShouldGetData(true)
                setRModal(false)
                setLoading(false)
                setStatus('Won')
            }
        })
    }

    return (
        <Modal
                    isOpen={rModal}
                    toggle={() => setRModal(false)}
                    style={{ maxWidth: '600px', marginTop: "6%", width: '100%' }}
                    className={`${AuthData.lang !== "ar" ? "" : "ar-wrapper"}`}
                >
                    <ModalHeader toggle={() => setRModal(false)}>
                    {t("Upload Receipt")}
              </ModalHeader>
                    <ModalBody>

                        <Row>
                            <Col md={12}>
                                <FileUpload
                                    accept='.jpg,.png,.jpeg,.JPG,.PNG,.JPEG'
                                    label={t('Receipt Photo')}
                                    attachmentType='media_id'
                                    setUpload={()=> {}}
                                    attachmentData={formState.media}
                                    updatedAttachment={updatedAttachment}
                                    deleteAttachment={deleteAttachment}
                                    setUploadState={setUploadState}
                                />
                            </Col>
                        </Row>
                        <Row className="d-flex justify-content-between ">
                            <Col  md={6}>
                                <button
                                    type="button"
                                    className="btn btn-secondary  btnHeight"
                                    onClick={() => {
                                        setRModal(false)
                                    }}
                                >
                                    {t("Cancel")}
                                </button>
                            </Col>
                            <Col md={6} className="d-flex justify-content-end">
                                <button
                                    onClick={()=> SubmitHandler()}
                                    className="btn btn-success  float-end btnHeight"
                                    disabled={uploadState ? true : loading ? true : false}
                                >
                                    {t("Submit")}
                                </button>
                            </Col>
                        </Row>

                    </ModalBody>
                </Modal>
    )
}

export default UploadReceiptModal;